import { Controller } from "stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {

  static targets = [ "profilePicture", "pictureSid", "uploading", "updateProfilePicture", "lblSessionTimeout", "swchAutoLogout", "rangeAutoLogout" ]

  static values = { }

  connect() {
    $("#loading").fadeOut('100');
  }

  selectProfilePicture() {
    var div = event.target.closest("div");
    var input = div.querySelector("#imgpicker");
    input.click();
  }

  deleteProfilePicture() {
    this.profilePictureTarget.innerHTML = '<i class="fa-solid fa-user fa-6x"></i>';
    this.pictureSidTarget.value = '';
    this.updateProfilePictureTarget.classList.remove("d-none");
  }

  uploadProfilePicture() {
    let that = this;
    var input = event.target;
    const url = input.dataset.directUploadUrl;

    var files = input.files.length;
    var count = 0;

    Array.from(input.files).forEach(file => {
      const upload = new DirectUpload(file, url);
      that.uploadingTarget.classList.remove('d-none');

      upload.create((error, blob) => {
        if (error) {
          console.log(`ERROR: ${error}`);
        } else {
          Rails.ajax({
            url: `/${I18n.locale}/users/picture/${btoa(blob.signed_id)}`,
            type: "get",
            data: "",
            success: function(data) {
              let img = document.createElement('img')
              img.src = data;
              img.classList.add('rounded-circle', 'profile-picture', 'border', 'border-secondary-subtl')
              img.style.maxHeight = '250px';
              img.style.maxWidth = '250px';
              that.profilePictureTarget.innerHTML = '';
              that.profilePictureTarget.appendChild(img);

              that.pictureSidTarget.value = btoa(blob.signed_id);
            },
            error: function(data) {}
          });
        }
        that.uploadingTarget.classList.add('d-none');
        that.updateProfilePictureTarget.classList.remove("d-none");
      })
    })

    input.value = '';
  }

  updateSessionTimeoutLabel() {
    this.lblSessionTimeoutTarget.innerHTML = (event.target.value == 1 ? `${event.target.value} ${I18n.t("time.hour")}` : `${event.target.value} ${I18n.t("time.hours")}`);
  }

  changeSessionTimeout() {
    let that = this;
    let timeout = event.target.value;
    Rails.ajax({
      url: `/${I18n.locale}/user/timeout/set`,
      type: "post",
      data: {
        timeout: timeout
      },
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      beforeSend(xhr, options) {
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
        options.data = JSON.stringify({"timeout": timeout})
        return true
      },
      dataType: 'json',
      success: function (data) {}
    });
  }

  toggleAutoLogout() {
    let auto_logout = event.target.checked;
    if(auto_logout) {
      this.rangeAutoLogoutTarget.removeAttribute("disabled");
    } else {
      this.rangeAutoLogoutTarget.setAttribute("disabled", true);
    }

    Rails.ajax({
      url: `/${I18n.locale}/users/settings/set`,
      type: "post",
      data: {},
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      beforeSend(xhr, options) {
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
        options.data = JSON.stringify({"attr": "session.auto_logout", "value": auto_logout})
        return true
      },
      dataType: 'json',
      success: function (data) {}
    });
  }
}
